import { Grid, styled } from "@mui/material";

export const StyledGrid = styled(Grid)({
  margin: "8px 0 14px 0",
  "& > div": {
    lineHeight: "24px",
  },
});
